import React, { useState } from 'react'
import Card from '../../components/card/Card';
import styles from "./auth.module.scss";
import { AiOutlineMail } from "react-icons/ai";
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { forgotPassword, validateEmail } from '../../services/authService';

const Login = () => {

    const [email, setEmail] = useState("")

    const forgot = async (e) => {
        e.preventDefault()

        //Validations
        if (!email) {
            return toast.error("Please Enter an Email")
        }

        if (validateEmail(email)) {
            return toast.error("Please Enter a Valid Email")
        }

        const userData = { email }
        await forgotPassword(userData)
        setEmail("")
    }

    return (
        <div className={`container ${styles.auth}`}>
            <Card>
                <div className={styles.form}>
                    <div className="--flex-center">
                        <AiOutlineMail size={35} color="#999" />
                    </div>
                    <h2>Forgot Password</h2>
                    <form onSubmit={forgot}>
                        <input type="text" placeholder='Email' required name='email' value={email} onChange={(e) => setEmail(e.target.value)} />
                        <button type='submit' className="--btn --btn-primary --btn-block">
                            Get Reset Email
                        </button>
                        <span className={styles.links}>
                            <p>
                                <Link to="/">-Home</Link>
                            </p>

                            <p>
                                <Link to="/login">-Login</Link>
                            </p>
                        </span>
                    </form>

                </div>
            </Card>
        </div>
    )
}

export default Login
